import styled from 'styled-components';
import { heights } from './style';

// components
import Tag, { TagProps } from './tag';

const SquareTag = styled(Tag)<TagProps>`
  width: ${props => heights[props.size || 'md']};
  padding: 0;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
`;

export default SquareTag;
